import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { AnimatedSection } from '../../../lib/animations/AnimatedSection';

export default function GalleryGrid({ section, data, theme }) {
  const anim = section.animation || {};
  const images = (data.images || []).filter(Boolean);
  const [lightboxImg, setLightboxImg] = useState(null);

  if (images.length === 0) return null;

  return (
    <>
      <section className="px-5 py-20" data-testid="gallery-section">
        <div className="max-w-sm mx-auto">
          <AnimatedSection preset={anim.items || 'fade-up'}>
            <p
              className="text-xs tracking-[0.3em] uppercase mb-8 text-center"
              style={{ color: theme.accent, fontFamily: theme.eyebrowFont }}
            >
              Gallery
            </p>
          </AnimatedSection>
          <div className="grid grid-cols-2 gap-2">
            {images.map((img, i) => (
              <AnimatedSection key={i} preset={anim.items || 'zoom-soft'} delay={i * 0.05}>
                <div
                  className={`overflow-hidden rounded-xl cursor-pointer transition-transform hover:scale-[1.02] ${
                    i === 0 ? 'col-span-2 aspect-[16/10]' : 'aspect-square'
                  }`}
                  onClick={() => setLightboxImg(img)}
                >
                  <img src={img} alt={`Gallery photo ${i + 1}`} className="w-full h-full object-cover" loading="lazy" />
                </div>
              </AnimatedSection>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {lightboxImg && (
        <motion.div
          className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90 p-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          onClick={() => setLightboxImg(null)}
        >
          <motion.img
            src={lightboxImg}
            alt="Gallery photo enlarged"
            className="max-w-full max-h-[85vh] rounded-lg object-contain"
            initial={{ scale: 0.9 }}
            animate={{ scale: 1 }}
          />
          <button
            className="absolute top-6 right-6 text-white/60 hover:text-white text-2xl"
            onClick={() => setLightboxImg(null)}
            aria-label="Close gallery lightbox"
          >
            &times;
          </button>
        </motion.div>
      )}
    </>
  );
}
